module.exports = __webpack_public_path__ + "img/banner-advisoryboard@1x.f639330e.jpg";